var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6095 22.5885L11.17 17.5905C10.924 17.46 10.624 17.478 10.3915 17.6355L3.17354 22.6335C2.90354 22.821 2.78654 23.1615 2.88554 23.475C2.98154 23.7855 3.27254 24 3.59954 24H20.257C20.6005 24 20.902 23.766 20.9845 23.43C21.0685 23.0955 20.9125 22.749 20.6095 22.5885Z",
    fill: "#1E1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7685 21.1635L21.5485 11.169C21.4945 10.9245 21.322 10.725 21.0895 10.6335C20.8555 10.542 20.593 10.5735 20.389 10.7145L13.1695 15.7125C12.9535 15.8625 12.832 16.113 12.8485 16.3725C12.8635 16.635 13.015 16.869 13.246 16.9905L22.684 21.9885C22.795 22.047 22.915 22.077 23.035 22.077C23.1955 22.077 23.356 22.026 23.4895 21.9225C23.722 21.7455 23.8315 21.45 23.7685 21.1635Z",
    fill: "#1E1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 9.5265C18.4465 9.213 18.157 9 17.8285 9H10.9825C9.73747 11.2545 7.89547 13.41 7.13797 14.253C6.71197 14.727 6.10147 15 5.46397 15C4.82647 15 4.21597 14.727 3.78997 14.253C3.49747 13.9275 3.04447 13.407 2.52547 12.762L0.710468 20.931C0.644468 21.2325 0.768968 21.543 1.02397 21.7155C1.14997 21.801 1.29697 21.843 1.44247 21.843C1.59247 21.843 1.74097 21.7995 1.86997 21.7095L18.2545 10.365C18.526 10.1805 18.6415 9.84 18.5455 9.5265Z",
    fill: "#1E1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46399 0C2.56899 0 0.213989 2.355 0.213989 5.25C0.213989 7.944 4.42599 12.7155 4.90599 13.251C5.04849 13.4085 5.25099 13.5 5.46399 13.5C5.67699 13.5 5.87949 13.4085 6.02199 13.251C6.50199 12.7155 10.714 7.944 10.714 5.25C10.714 2.355 8.35899 0 5.46399 0ZM5.46399 7.5C4.22199 7.5 3.21399 6.492 3.21399 5.25C3.21399 4.008 4.22199 3 5.46399 3C6.70599 3 7.71399 4.008 7.71399 5.25C7.71399 6.492 6.70599 7.5 5.46399 7.5Z",
    fill: "#1E1A1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/areaIcon.cbbe751398930ab83ac1d4dbc43230ad.svg";
export { ForwardRef as ReactComponent };